const initialState = {
    responseNotificationsList: {},
    responseNotifications: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "NOTIFICATIONS_LIST_RESPONSE":
            newState.responseNotificationsList = action.value
            break;
        case "NOTIFICATIONS_RESPONSE":
            newState.responseNotifications = action.value
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;